import styled from 'styled-components';
import { Trans } from '@lingui/react';
import {
    SectionContainer,
    ContentWrapper,
    SectionSmallerHeading,
    SectionWrapper,
    tabletBreakpoint,
} from '~/styles/common';

import TransHTML from '~/components/transHTML';
import { t } from '@lingui/macro';

function Devil() {
    return (
        <SectionContainer id="payment-acceptance">
            <ContentWrapper>
                <DevilSectionWrapper>
                    <DevilSectionSmallerHeading>
                        <Trans id="global.pricing.devil.smaller_heading" />
                    </DevilSectionSmallerHeading>
                    <Row>
                        <Item>
                            <ItemTick src="/static/images/new_web/green_tick.svg" />
                            <ItemDescription>
                                <TransHTML
                                    id={t`global.pricing.devil.by_free`}
                                />
                            </ItemDescription>
                        </Item>
                        <Item>
                            <ItemTick src="/static/images/new_web/green_tick.svg" />
                            <ItemDescription>
                                <TransHTML
                                    id={t`global.pricing.devil.free_of_charge`}
                                />
                            </ItemDescription>
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <ItemTick src="/static/images/new_web/green_tick.svg" />
                            <ItemDescription>
                                <TransHTML
                                    id={t`global.pricing.devil.four_percents`} />
                            </ItemDescription>
                        </Item>
                        <Item>
                            <ItemTick src="/static/images/new_web/green_tick.svg" />
                            <ItemDescription>
                                <TransHTML
                                    id={t`global.pricing.devil.premium`}
                                />
                            </ItemDescription>
                        </Item>
                    </Row>
                </DevilSectionWrapper>
            </ContentWrapper>
        </SectionContainer>
    );
}

export default Devil;

const DevilSectionWrapper = styled(SectionWrapper)`
    flex-direction: column;
`;

const DevilSectionSmallerHeading = styled(SectionSmallerHeading)`
    margin-bottom: 0px;
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 50px;

    @media (max-width: ${tabletBreakpoint}) {
        flex-direction: column;
        margin-top: 0px;
    }
`;

const Item = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex: 1 1;
    align-items: flex-start;

    &:first-child {
        margin-right: 30px;
    }

    &:last-child {
        margin-left: 30px;
    }

    @media (max-width: ${tabletBreakpoint}) {
        &:first-child {
            margin-right: 0px;
        }

        &:last-child {
            margin-left: 0px;
        }
        margin-top: 35px;
    }
`;

const ItemTick = styled.img`
    margin-right: 20px;
    margin-top: 8px;
`;

const ItemDescription = styled.div`
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0.5px;
    color: #525252;

    @media (max-width: ${tabletBreakpoint}) {
        font-size: 16px;
        line-height: 29px;
    }
`;

